import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {contentPresetList_template} from "../components/templates/contentPresetList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class content_preset extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected contentPresetList: contentPresetList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.contentPresetList = new contentPresetList_template("contentPresetList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Content presets List");
        return [this.contentPresetList.build()];
    }

    protected getModuleName(): string {
        return "content_preset";
    }

    fillPage() {
        this.getContentPresetData();
    }

    protected getContentPresetData() {
        this.loadingIn(this.contentPresetList.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.contentPresetList.getViewModelForRequest())]);

        let url: string = '/api/brand/' + idBrand + "/contentpreset/get/";

        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);

        this.XHRHdl.onReadyStateFunction = this.ongetContentPresetDataReturn;
        this.XHRHdl.execute();
    }

    protected ongetContentPresetDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let content_presets = responseParsed.data;


                obj.viewModel.contentPresetList.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.contentPresetList.setResultInfo(totalCount, totalPage, execTime)

                obj.contentPresetList.setContentPresets(content_presets, obj.getBrandId());

            });
            obj.loadingOut(obj.contentPresetList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected contentPresetsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.getContentPresetData()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.getContentPresetData();
    }

    protected viewContentPreset(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/content-presets/view/' + id + '/')
    }

    protected addContentPreset() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/content-presets/add/')
    }

    protected deleteContentPreset(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/contentpreset/delete/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.contentPresetList.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Content preset" + "<strong>" + data.itemName + "</strong>" + "was successfully deleted");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.getContentPresetData()
                })

                obj.loadingOut(obj.contentPresetList.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

}


// WEBPACK FOOTER //
// ./js/modules/content_preset.ts